


































































import {
  defineComponent, computed,
} from '@vue/composition-api'
import { useVModel } from '@vueuse/core'

export default defineComponent({
  props: {
    aggregationCatalogs: {
      type: Array,
      required: true,
    },
    selectedAggregationTemplate: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    const selectedTemplate = useVModel(props, 'selectedAggregationTemplate', emit)

    const handleAggregationTemplateInput = (value: any) => {
      emit('input', { id: value.id })
    }

    return {
      selectedTemplate,
      handleAggregationTemplateInput,
    }
  },
})
